export const CHECKOUT_SESSION_STORAGE_KEY = 'polyshop_checkout_session';

export const CHECKOUT_SESSION_TIMEOUT_MINUTES = 30;

export const CHECKOUT_SESSION_MIN_RESUME_MINUTES = {
  shipping: 5,
  payment: 3,
} as const;
